import type { FaireProductEntity } from "../../entity_types/product";

export const p_1ws7ty688t: FaireProductEntity = {
  token: "p_1ws7ty688t",
  type: "product",
  name: "Marble Bull  Frog 2''",
  brandToken: "b_4e6hayu5vx",
  brandName: "SS handcrafted Art",
  imageUrl:
    "https://cdn.faire.com/fastly/0135ce8f4dedc610dac0068de45c83dc2c1629ecff0ca720b5bcaec390d209c8.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.3,
  description:
    "Color variations are expected\n\nSizes are approximate\n\nHandcrafted out of natural marble, in Ecuador\n\nWith every purchase, a portion goes to The Turtleman Foundation to help save one sea turtle at a time",
  tags: [],
  msrpDollars: 8.45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:04.515Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
